import { createContext } from 'react';

export const StructureContext = createContext({name: "", id: 0});

export const MyStructuresContext = createContext([]);
